import { render, staticRenderFns } from "./NewRequestEquipment.vue?vue&type=template&id=9620e0bc&"
import script from "./NewRequestEquipment.vue?vue&type=script&lang=js&"
export * from "./NewRequestEquipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports